import { isPerfMetricsEnabled } from '../../lib/debug/performance';

import Lz4StatsDebug from '../Lz4StatsDebug/Lz4StatsDebug';
import PerfMetricsDebug from '../PerfMetricsDebug/PerfMetricsDebug';
import SubscriptionTimingDebug from '../SubscriptionTimingDebug/SubscriptionTimingDebug';

import styles from './DebugPanels.module.scss';

/**
 * The bottom-right debug stack. Owns placement so the panels never overlap and none of them has
 * to position itself. Mounted once at the app root, so every route gets the same stack.
 *
 * The column ignores pointer events; only the controls inside a panel take them back, so the
 * overlay can never block the UI underneath it.
 *
 * Shown only with `?debug=performance` in the URL - reload without it to hide.
 */
const DebugPanels = () => {
  if (!isPerfMetricsEnabled()) {
    return null;
  }

  return (
    <div className={styles.stack}>
      <Lz4StatsDebug />
      <PerfMetricsDebug />
      <SubscriptionTimingDebug />
    </div>
  );
};

export default DebugPanels;
